/**
 * Auto-generated feature codes from backend registry.
 * DO NOT EDIT MANUALLY - run: python manage.py generate_feature_types
 *
 * Source: server/apps/feature/registry.py
 */

export enum FeatureCode {
  DEVICE_MANAGEMENT = 'device_management',
  POST_MISSING_REPORT = 'post_missing_report_on_chat',
  NOTIFY_AUTH_TOKEN = 'notify_user_on_auth_token',
  DUTY_STATUS = 'duty_status',
  REPORT_INCIDENT = 'report_incident',
  UPDATE_SYSTEM_POST_TO_ALERT_CHAT = 'update_system_post_to_alert_chat',
  REMOVE_LOCATION_FROM_CHAT_ON_LOCATION_UPDATE = 'remove_location_from_chat_on_location_update',
  REPORT_ROSTER = 'report_roster',
  REUNIFICATION = 'reunification',
  VISITOR_MANAGEMENT = 'visitor_management',
  NOTIFICATION_CENTER = 'notification_center',
  INCIDENT_MESH = 'incident_mesh',
  ACCOUNT_DOCUMENTS = 'account_documents',
  ACCOUNT_BILLING = 'account_billing',
  SITE_PLANS = 'site_plans',
  BACKGROUND_LOCATION = 'background_location',
  LIVE_ALERT_POSITIONS = 'live_alert_positions',
  GUIDED_TOUR = 'guided_tour',
  PROVIDER_INVITATIONS = 'provider_invitations',
  ACCESSIBLE_ROOM_INDICATORS = 'accessible_room_indicators',
  SITE_PRESELECTED_PROVIDER_AUTO_INVITES = 'site_preselected_provider_auto_invites',
  IPAWS_ORIGINATION = 'ipaws_origination',
  MASS_NOTIFICATION_CONTACTS = 'mass_notification_contacts',
  INTERNAL_SERVICE_AUTH_ENFORCE = 'internal_service_auth_enforce',
  USER_MANUAL = 'user_manual',
  ALERT_ESCALATION = 'alert_escalation',
  USER_ONBOARDING = 'user_onboarding',
  SOUND_LIBRARY = 'sound_library',
}

/**
 * Feature flag from API
 */
export interface Feature {
  id: number;
  name: string;
  codename: FeatureCode;
  description: string;
  release: boolean;
}

/**
 * Organization-specific feature toggle
 */
export interface FeatureToggle {
  id: number;
  feature: number; // Feature ID
  district: number; // District ID
  flag: boolean;
}

/**
 * Combined feature with toggle information
 */
export interface FeatureWithToggle extends Feature {
  toggle?: FeatureToggle;
}
